import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=2399c6c2&"
import script from "./VehicleList.vue?vue&type=script&lang=js&"
export * from "./VehicleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports